import Vue from 'vue'
import Router from 'vue-router'
import { AccountType } from '@/constant/user'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
  },
  {
    path: '/bindAccount',
    name: 'bindAccount',
    component: () =>
      import(/* webpackChunkName: "bindAccount" */ '@/views/bindAccount/index.vue'),
  },
  {
    path: '/404',
    name: 'error',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
  },
]

export const asyncRouterMap = [
  {
    path: '/familyTrain',
    name: 'familyTrain',
    component: () =>
      import(/* webpackChunkName: "train" */ '@/views/familyTrain/index.vue'),
    meta: {
      roles: [
        AccountType.BASIS,
        AccountType.ADVANCED,
        AccountType.ADJUSTMENT,
        AccountType.MYOPIA,
      ],
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/home/index.vue'),
    meta: { roles: [AccountType.HOSPITAL] },
    children: [
      {
        path: 'shopTrain',
        name: 'shopTrain',
        component: () =>
          import(/* webpackChunkName: "rs" */ '@/views/shopTrain/index.vue'),
        meta: { roles: [AccountType.HOSPITAL] },
      },
      {
        path: 'examine',
        name: 'examine',
        component: () =>
          import(/* webpackChunkName: "rs" */ '@/views/examine/index.vue'),
        meta: { roles: [AccountType.HOSPITAL] },
      },
    ],
  },
  {
    path: '/alipay',
    name: 'alipay',
    component: () =>
      import(/* webpackChunkName: "alipay" */ '@/views/alipay/index.vue'),
    meta: {
      roles: [
        AccountType.BASIS,
        AccountType.ADVANCED,
        AccountType.ADJUSTMENT,
        AccountType.MYOPIA,
      ],
    },
  },
  { path: '*', name: 'err404', redirect: '/404' },
]

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
})
